import type { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import type { IDatePicker, IWedding } from '@bridebook/models/source/models/Weddings.types';
import type { IDatePickerUI } from '@bridebook/toolbox/src/datepicker/types';
import type { IUISupplier, Slug } from '@bridebook/toolbox/src/types';
import type { TWithSupplierData } from '@bridebook/web/app-shared/lib/supplier/supplier-types';
import { EnquiryIntents } from '@bridebook/web/lib/enquiries/intent';
import type {
  EnquiryPlannerOrigin,
  EnquiryPlannerResult,
} from '@bridebook/web/lib/enquiries/planner-enquiry';

export enum EnquiryContext {
  Brochure = 'supplierBrochure',
  Quote = 'supplierQuote',
  Showround = 'supplierShowround',
  Fairs = 'supplierFairs',
  MoreAvailability = 'supplierMoreAvailability',
}

export interface EnquiryFormInfoProps {
  method?: string;
  locationType?: string;
  actionLabel?: string;
  closeMethod?: string;
  contactGalleryCTA?: number | 'end';
  errorMessage?: string;
  enquiry?: any;
  defaultIntent?: keyof EnquiryIntents;
  /** cta is used in analytics
   pass the copy in english */
  cta?: string;
  /** translated copy for the button */
  buttonCopy?: string;
  contactLocation?: string;
  contactSection?: string;
  contactMethod?: string;
  context?: EnquiryContext;
  fair?: {
    date: string;
    name: string;
  };
  numberOfActiveShowroundSlots?: number;
  numberOfActiveOpenDays?: number;
}

export interface IUserEnquiries {
  [k: string]: IUserEnquiriesItem | number;
}

interface IUserEnquiriesItem {
  createdAt: number;
}

export interface EnquiryFormFieldsType {
  partners: Array<string>;
  email: string;
  weddingDate?: IDatePicker;
  weddingDateDatePicker: IDatePickerUI | null;
  message: string;
  guestsInitialTarget: number;
  location: IWedding['location'];
  phone: string;
  totalWeddingBudget: IWedding['budget'];
}

// Keys equal to enquiry ids and number equals to enquiry date
export type TEnquiryDates = Record<string, number>;

export interface IEnquiryDate {
  supplierId: string;
  enquired: number;
  type: Slug;
}

export interface IEnquiriesState {
  userEnquiryAnalyticsMethod: string;
  showEnquiryForm: boolean;
  startInEditMode: boolean;
  enquirySupplier: IUISupplier | null;
  enquiryConfirmationScreenShown: boolean;
  intent: EnquiryIntents;
  multipleEnquiry: boolean;
  enquiryConfirmationSupplier: TWithSupplierData<ISupplier> | null;
  enquiredSuppliersCount: number;
  onPageEnquiry?: boolean;
  enquiryDates: IEnquiryDate[];
  showUserLimit: boolean;
  loggedOutEnquiryTriggered: boolean;
  infoProps: EnquiryFormInfoProps;
  // The planner proposal the open form was started from.
  plannerOrigin: EnquiryPlannerOrigin | null;
  // What a form send reported for each proposal, by tool call id, until its card reads it.
  plannerResults: Record<string, EnquiryPlannerResult>;
}

export interface IEnquiryFormToggleArgs {
  show: boolean;
  infoProps?: EnquiryFormInfoProps;
  track?: boolean;
  multipleEnquiry?: boolean;
  supplier?: IUISupplier | null;
  resetEnquiry?: boolean;
  startInEditMode?: boolean;
  plannerOrigin?: EnquiryPlannerOrigin | null;
}
